<!-- BOM物料 -->
<template>
  <BaseFormItem
    class="buy_bom"
    :label="fields.label"
    :isShowLabelTitle="false"
    :labelTips="fields.labelTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
  >
    <BaseRadioGroup2 v-model="val" @change="handleEmit">
      <BaseTipPopover 
        v-for="item in fields.options"
        :key="item.value" 
        :content="item.tips" 
        :disabled="!item.tips"
      >
        <el-radio
          border
          slot="reference"
          class="insurance_type_radio"
          :label="item.value"
          :disabled="item.disabled"
        >
          <span>{{ item.label }}</span><br/>
          <span v-if="item.desc" class="buy_bom__desc">
            {{ item.desc }}
          </span>
          <span v-if="item.badge" class="buy_bom__badge">
            {{ item.badge }}
          </span>
          <span v-if="item.value === 2" class="buy_bom__feeIcon">收费<img src="@@/assets/img/common/question.png" class="buy_bom__feeIcon__img"/></span>
        </el-radio>
      </BaseTipPopover>
    </BaseRadioGroup2>
  </BaseFormItem>
</template>

<script>
import { getSMTFields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      val: this.value,
      currentItem: {},
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
    }
  },
  computed: {
    fields() {
      return getSMTFields('buy_bom')
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    },
    item(item) {
      this.currentItem = item
    },
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.handleEmitChange()
    },
    handleEmitChange() {
      const { val, currentItem } = this
      this.$emit('change', val, val === 3 && currentItem.bomSn ? currentItem : {})
      this.isShowError(false)
    },
    // 是否显示错误提示样式
    isShowError(isShow, isBlink = false) {
      this.isError = isShow
      this.isErrorBlink = isBlink
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@@/styles/mixin.scss';
.buy_bom {
  ::v-deep {
    .base-radio-group {
      margin-bottom: -10px;
      .el-radio.is-bordered {
        width: 152px;
        height: 52px;
        margin-bottom: 10px;
        margin-left: 0;
        margin-right: 10px;
      }
    }
  }
  // .buy_bom__radio {
  //   position: relative;
  // }
  .buy_bom__desc {
    display: inline-block;
    color: $--color-text-placeholder;
    font-size: 12px;
    margin-top: 8px;
  }
  .buy_bom__feeIcon {
    position: absolute;
    right: -1px;
    top: -1px;
    width: 48px;
    height: 16px;
    font-size: 12px;
    line-height: 16px;
    color: #fff;
    text-align: center;
    background: #e6a23c;
    border-radius: 0px 3px 0px 3px;
    padding: 2px;
  }
  .buy_bom__feeIcon__img {
    width: 14px;
    margin-left: 4px;
    display: inline-block;
    vertical-align: text-bottom;
  }
}
</style>